import { FORM_ACTIONS } from "../actions";
import { BOOKING_ACTION } from "../../BookingPortal/actions";
import { deepAssign } from "../../../utils";

const INITIAL_STATE = {
  firstName: "",
  lastName: "",
  mobile: "",
  email: "",
  confirm_email: "",
  dateOfBirth: "",
  customFields: {},
  errors: {},
  verifyCode: "",
  smsCount: 0,
  isVerifyDrawerOpen: false
};

// const TEST_STATE = {
//   firstName: "test()",
//   lastName: 'test"',
//   mobile: "0410000000",
//   email: "test@email.com",
//   confirm_email: "test@email.com",
//   dateOfBirth: "09/05/2002",
//   customFields: {},
//   errors: {},
//   verifyCode: "",
//   smsCount: 0,
//   isVerifyDrawerOpen: false
// };

const updatePersonalDetail = (state, action) => {
  const { prop, value } = action.payload;
  return { ...state, [prop]: value };
};

const showErrorMessage = (state, action) => {
  const { prop, errorMessage } = action.payload;
  return deepAssign(state, errorMessage, ["errors", prop]);
};

const storeVerifyCode = (state, action) => {
  return {
    ...state,
    verifyCode: action.payload.verifyCode,
    smsCount: state.smsCount + 1
  };
};

export const personalDetailReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FORM_ACTIONS.UPDATE_PERSONAL_DETAIL:
      return updatePersonalDetail(state, action);

    case FORM_ACTIONS.SHOW_ERROR_MESSAGE:
      return showErrorMessage(state, action);

    case FORM_ACTIONS.STORE_VERIFY_CODE:
      return storeVerifyCode(state, action);

    case FORM_ACTIONS.TOGGLE_VERIFY_DRAWER:
      return { ...state, isVerifyDrawerOpen: action.payload.open };

    case BOOKING_ACTION.MAKE_NEW_BOOKING:
      return INITIAL_STATE;

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/ContactForm/reducers/personalDetailReducer.js